import work from './work';

const hunter = {
	consume: { food: 1, water: 1 },
	resilience: { food: 0.5, water: 1 },
	craftsmanship: { craftsmanship: 1 },
	luck: { luck: 1 },
	charisma: { charisma: 1 },
	startBonus: { food: 50, ammo: 50 },

	work: { [work.forage]: 1.5, [work.craft]: 1, [work.fabricate]: 1 },
};

export default hunter;
